import { getEnabledElement } from './enabledElements.js';
import getImageFitScale from './internal/getImageFitScale.js';
import updateImage from './updateImage.js';

/**
 * Adjusts an image's scale and translation so the image is centered and all pixels
 * in the image are viewable.
 *
 * @param {HTMLElement} element The Cornerstone element to update
 * @returns {void}
 */
function fitToWindow(element) {
  const enabledElement = getEnabledElement(element);
  const { canvas, image, viewport } = enabledElement;

  // The new scale is the minimum of the horizontal and vertical scale values
  viewport.scale = getImageFitScale(canvas, image, viewport.rotation).scaleFactor;
  viewport.translation.x = 0;
  viewport.translation.y = 0;

  updateImage(element);
}

export default fitToWindow;
